import { FilterRemoveIcon, IconButton, IconButtonProps, Tooltip } from 'evergreen-ui';
import React from 'react';

/**
 * Кнопка для сброса фильтров.  
 * Нужно обязательно блокировать кнопку, когда нечего сбрасывать
 * */
export function ResetFilters(props: IconButtonProps & {disabled: boolean}) {
  return (
    <Tooltip content="Сбросить фильтр">
      <IconButton
        icon={FilterRemoveIcon}
        appearance="primary"
        // @ts-ignore
        intent={null}
        {...props}
      />
    </Tooltip>
  );
}
export const MemoResetFilters = React.memo(ResetFilters);
MemoResetFilters.displayName = 'MemoResetFilters';
export default ResetFilters;
